import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[issSelectedOption]',
  standalone: true,
})
export class SelectedOptionDirective<T> {
  public constructor(public readonly templateRef: TemplateRef<T>) {}
}
